import { render, staticRenderFns } from "./RELTempoPlacaServico.vue?vue&type=template&id=52c291fa&"
import script from "./RELTempoPlacaServico.vue?vue&type=script&lang=js&"
export * from "./RELTempoPlacaServico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports